import * as React from 'react'
import styled from 'styled-components'
import * as t from './types'
import PositionIndicator from './PositionIndicator'
import theme from 'theme'
import useArrowNavigation from 'hooks/useSliderArrowNavigation'
import Teaser from '../Teaser'
import usePersonalization from 'hooks/usePersonalization'
import SliderButton from 'theme/atoms/SliderButton'
import useTranslations from 'hooks/useTranslations'
import withTranslations from './withTranslations'

export function BrandSlider(props: t.Props) {
  const arrowNav = useArrowNavigation(0.8)
  const products = props.brands
  const layoutSize = props.layoutSize ? props.layoutSize : 'normal'
  const personalization = usePersonalization()
  const t = useTranslations<'organisms-BrandTeaserList'>()

  return (
    <Wrapper
      className="BrandSlider"
      $visible={products.length > 0 ? true : false}
      $layoutSize={layoutSize}
      data-cy-state={props['data-cy-state']}
    >
      <div className="innerSlider">
        <div className="products" ref={arrowNav.productListRef}>
          <Indicator ref={arrowNav.firstItemRef} $width={1} />
          {products.slice(0, props.maxProducts).map((product, i) => (
            <div className="widget-wrapper" key={i}>
              <Teaser
                imgSrc={props.brands[i].imgSrc}
                name={product.name}
                to={product.link}
                tracking={() => personalization.trackClick()}
              />
            </div>
          ))}
          <Indicator ref={arrowNav.lastItemRef} $width={1} />
        </div>
        {!arrowNav.firstItemReached && (
          <SliderButton
            facing="left"
            title={t.asText(false, 'brand_slider_prev_button_title')}
            data-cy-handle="prev-button"
            data-cy-state="has-prev-button"
            onClick={() => arrowNav.handleSlide('left')}
          />
        )}
        {!arrowNav.lastItemReached ? (
          <SliderButton
            facing="right"
            title={t.asText(false, 'brand_slider_next_button_title')}
            data-cy-handle="next-button"
            data-cy-state="has-next-button"
            onClick={() => arrowNav.handleSlide('right')}
          />
        ) : null}
      </div>
      {!props.hideScrollbar && (
        <PositionIndicator
          data-cy-state="show-position-indicator"
          componentRef={arrowNav.productListRef}
          maxSteps={props.brands.length}
          offset={1}
          displayedSteps={props.brands.length}
        />
      )}
    </Wrapper>
  )
}

export default withTranslations(BrandSlider)

const Wrapper = styled.div<{ $visible: boolean; $layoutSize: string }>`
  width: 100%;
  max-width: var(--container-size);
  position: relative;
  ${(props) => !props.$visible && `display:none;`}

  > h3 {
    color: ${theme.colors.b0};
    margin-top: ${theme.spacing('m')};
    ${theme.ty('rc-2xl')}
  }

  .innerSlider {
    position: relative;
    display: flex;
    align-items: center;
    > .products {
      display: flex;
      width: 100%;
      max-width: 1260px;
      overflow-x: scroll;
      scrollbar-width: none;
      padding-bottom: ${theme.spacing('m')};

      ::-webkit-scrollbar {
        width: 0;
        background: transparent;
      }

      > .widget-wrapper {
        margin-right: ${theme.spacing('xs')};
        > * {
          width: 100%;
        }
      }
    }
  }
`

const Indicator = styled.div<{ $width: number }>`
  width: ${(p) => p.$width + 'px'};
  min-width: ${(p) => p.$width + 'px'};
  height: 0.0625rem;
  align-self: center;
`
